import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';

function BuildingMaterialModal({
  createBuildingMaterial,
  getBuildingMaterialTypeList,
  history,
  type,
  updateBuildingMaterial,
  updateList,
  id,
  materialTypeId,
  getSingleMaterialType,
}) {

  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
  });

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createBuildingMaterial(materialTypeId, formData, () => {
        setModal({ isOpen: false });
        getBuildingMaterialTypeList();
        history.push(`/rpt/building/settings/building-materials/${materialTypeId}`);
        getSingleMaterialType(materialTypeId);
      });
    }

    if (type === 'EDIT') {
      updateBuildingMaterial(materialTypeId, id, formData, () => {
        setModal({ isOpen: false });
        getBuildingMaterialTypeList();
        history.push(`/rpt/building/settings/building-materials/${materialTypeId}`);
        getSingleMaterialType(materialTypeId);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    setFormData(updateList);
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Name{' '}
              {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Description{' '}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BuildingMaterialModal.defaultProps = {
  type: '',
  updateList: {},
  id: '',
  materialTypeId: '',
};

BuildingMaterialModal.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  materialTypeId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getBuildingMaterialTypeList: PropTypes.instanceOf(Function).isRequired,
  createBuildingMaterial: PropTypes.instanceOf(Function).isRequired,
  updateBuildingMaterial: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleMaterialType: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BuildingMaterialModal);
